export const getTimeDifferenceApproximation = (date) => {
  const givenDate = new Date(date);
  const currentDate = new Date();
  const timeDifference = currentDate - givenDate;

  const seconds = Math.floor(timeDifference / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  const days = Math.floor(hours / 24);
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30);
  const years = Math.floor(months / 12);

  if (hours < 1) {
    return { minutes };
  }

  if (days < 1) {
    return { hours };
  }

  if (weeks < 1) {
    return { weeks };
  }

  if (months < 1) {
    return { days };
  }

  if (years < 1) {
    return { months };
  }

  return { years };
};

export const formatLifespan = (days) => {
  if (!days || days === 0) return "N/A";

  const totalDays = parseInt(days);
  if (isNaN(totalDays)) return "N/A";

  const months = Math.floor(totalDays / 30);
  const remainingDays = totalDays % 30;

  if (months === 0) {
    return `${remainingDays} day${remainingDays !== 1 ? "s" : ""}`;
  }

  if (remainingDays === 0) {
    return `${months} month${months !== 1 ? "s" : ""}`;
  }

  return `${months} month${months !== 1 ? "s" : ""} ${remainingDays} day${remainingDays !== 1 ? "s" : ""}`;
};
